/* ============================================================================
   BB Collection v10 — additive behaviour, loaded after bb-coffee.js.
   Adds: per-card "More" detail toggle, compare mode, saved-coffees drawer.
   Does NOT duplicate the favourites store — it reads the same localStorage key
   bb-coffee.js writes (FKEY must stay in sync with that file).

   Filename still says v5 because sections/bb-collection-main.liquid references
   it; contents are the current v10 card behaviour.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__bbcV5Init) return; window.__bbcV5Init = true;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var FKEY = 'bbc-favs';
  function favSet() { try { return new Set(JSON.parse(localStorage.getItem(FKEY) || '[]')); } catch (e) { return new Set(); } }

  /* ---- per-card "More" toggle ----
     Looks the panel up WITHIN the card rather than as the button's next
     sibling: the toggle now lives inside .buy-left, so nextElementSibling is
     null. Never sets textContent here either — that would delete the chevron
     SVG inside the button. The chevron flips via [aria-expanded] in CSS. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bbc-detail]');
    if (!t) return;
    var card = t.closest('.card');
    var panel = card && card.querySelector('.details');
    if (!panel) return;
    var open = panel.classList.toggle('open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- Get Matched: hide where there is no quiz to open ----
     The button targets #bbc-quiz, which only exists on the collection template.
     The PDP "tastes like this" shelf renders the same card, so there the button
     would be a no-op. Hide it rather than ship a dead control. */
  if (!document.getElementById('bbc-quiz')) {
    $$('.bb-card-v10 [data-bbc-open="bbc-quiz"]').forEach(function (b) { b.hidden = true; });
  }

  /* ---- compare mode: open every card's detail panel at once ----
     The root MUST be resolved from the button outwards. `.bbc-root` is not unique:
     the collection template paints it on five wrappers (circle row, hero, trust bar,
     #bbc-app and the FAQ), so document.querySelector('.bbc-root') returned the circle
     row — a decorative div with no cards in it. The class landed there, the button
     label flipped to "Browse", and absolutely nothing else happened. Verified broken
     on the live draft theme 28 Jul; the CSS was correct the whole time. */
  var compareBtn = document.getElementById('bbc-compareToggle');
  var root = compareBtn ? compareBtn.closest('.bbc-root') : null;
  if (!root) root = document.getElementById('bbc-app');
  if (compareBtn && root) {
    compareBtn.addEventListener('click', function () {
      var on = !root.classList.contains('compare-mode');
      root.classList.toggle('compare-mode', on);
      compareBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* D-toolbar, 29 Jul: this button is ICON-ONLY now. It used to do
         `compareBtn.textContent = on ? 'Browse' : 'Compare'`, which would
         delete the SVG inside it and leave a blank circle — exactly the trap
         already documented for the card's detail toggle at the top of this
         file. The pressed state is carried visually by [aria-pressed] in
         bb-toolbar-icons.css; only the labels change here. */
      var lbl = on ? 'Browse' : 'Compare';
      compareBtn.setAttribute('aria-label', lbl);
      compareBtn.setAttribute('title', lbl);
      compareBtn.setAttribute('data-bbc-iclabel', lbl);
    });
  }

  /* ---- saved-coffees drawer ----
     v1 limit: can only show image/name/price for products currently rendered
     in the DOM. A favourite saved on another page shows once its card loads. */
  var savedList = document.getElementById('bbc-savedList');
  function renderSaved() {
    var f = favSet();
    $$('.saved-count').forEach(function (el) { el.textContent = String(f.size); });
    /* the toolbar heart fills once anything is saved */
    $$('.saved-toggle').forEach(function (el) { el.classList.toggle('has-saved', f.size > 0); });
    syncAddAll();
    if (!savedList) return;
    if (f.size === 0) {
      savedList.innerHTML = '<p class="saved-empty">Coffees you save will show up here.</p>';
      return;
    }
    var rows = [];
    f.forEach(function (id) {
      var card = document.querySelector('.card[data-bbc-item="' + id + '"]');
      if (!card) return;
      var link = card.querySelector('.card-title a');
      var img = card.querySelector('.bag img');
      /* .price holds a visible span AND a visually-hidden one for screen
         readers; reading the whole element concatenates both ("AED47AED 47.00"). */
      var priceVisible = card.querySelector('.priceline .price [aria-hidden="true"]');
      if (!link) return;
      rows.push(
        '<div class="saved-item">' +
        (img ? '<img src="' + img.src + '" alt="" loading="lazy">' : '') +
        '<div><a class="si-name" href="' + link.getAttribute('href') + '">' + link.textContent.trim() + '</a>' +
        (priceVisible ? '<div class="si-price">' + priceVisible.textContent.trim() + '</div>' : '') +
        '</div></div>'
      );
    });
    savedList.innerHTML = rows.length ? rows.join('') : '<p class="saved-empty">Coffees you save will show up here.</p>';
  }
  renderSaved();
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-bbc-fav]')) setTimeout(renderSaved, 0);
  });

  /* Cards appended by "Load more" need their bookmark state painted and the
     saved count kept honest. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#bbc-loadMore')) setTimeout(renderSaved, 700);
  });

  /* ---- open-handler fallback for cards appended after page load ----
     bb-coffee.js binds [data-bbc-open] once, directly, at script load. Load-more
     inserts fresh cards with insertBefore and re-paints favourites, but never
     re-binds — so "Get Matched" and "How this was estimated" on page 2+ would be
     dead buttons. Everything present at load is recorded here and left alone
     (double-handling would call its scroll-lock twice and jump the page); only
     later arrivals get opened by us, and we track our own open panel so the
     shared [data-bbc-close] still shuts it. */
  var boundAtLoad = new WeakSet();
  $$('[data-bbc-open]').forEach(function (b) { boundAtLoad.add(b); });
  var myOpen = null;

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bbc-open]');
    if (!b || boundAtLoad.has(b)) return;
    var el = document.getElementById(b.getAttribute('data-bbc-open'));
    if (!el) return;
    e.preventDefault();
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bbc-locked');
    myOpen = el;
  });

  document.addEventListener('click', function (e) {
    if (!myOpen) return;
    var closing = (e.target.closest && e.target.closest('[data-bbc-close]')) ||
                  (e.target.hasAttribute && e.target.hasAttribute('data-bbc-overlay') && e.target === e.target.closest('[data-bbc-overlay]'));
    if (!closing) return;
    myOpen.classList.remove('open');
    myOpen.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bbc-locked');
    myOpen = null;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !myOpen) return;
    myOpen.classList.remove('open');
    myOpen.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bbc-locked');
    myOpen = null;
  });

  /* ==========================================================================
     ADD ALL TO BAG  (D-P2c, Salem 28 Jul)
     Two entry points, one code path:
       · the applied-filter row — "add everything in the set I just narrowed to";
       · the saved drawer — "add everything I marked".
     Both post a single /cart/add.js with an items[] array rather than looping
     one request per product: one round trip, one cart re-render, and Shopify
     either takes the whole batch or none of it, so we never leave a half-filled
     cart behind if one line is out of stock.

     Scope is always the cards currently in #bbc-grid. That is the same v1
     limitation the saved drawer already has — a coffee saved on another page is
     not in this DOM, so it cannot be added from here — and the button counts
     only what it can actually add, so the number never overstates.
     ========================================================================== */
  /* declaration, not `var GRID = function(){}` — renderSaved() runs further up this
     file and calls syncAddAll(), which needs GRID before the assignment would run. */
  function GRID() { return document.getElementById('bbc-grid'); }

  function addableIn(scope) {
    if (!scope) return [];
    var seen = {}, out = [];
    $$('[data-bbc-add]', scope).forEach(function (b) {
      /* the discovery pack carries a required flavour-chip property — adding it
         silently from a bulk action would ship a pack nobody chose notes for */
      if (b.hasAttribute('data-bbc-discovery') || b.closest('.card--discovery')) return;
      if (b.disabled || b.hasAttribute('disabled')) return;
      var id = parseInt(b.getAttribute('data-bbc-add'), 10);
      if (!id || seen[id]) return;
      seen[id] = 1;
      out.push({ id: id, quantity: 1 });
    });
    return out;
  }

  function addableSaved() {
    var grid = GRID();
    if (!grid) return [];
    var out = [];
    favSet().forEach(function (pid) {
      var card = grid.querySelector('.card[data-bbc-item="' + pid + '"]');
      if (card) out = out.concat(addableIn(card));
    });
    var seen = {};
    return out.filter(function (i) { if (seen[i.id]) return false; seen[i.id] = 1; return true; });
  }

  function syncAddAll() {
    var f = document.getElementById('bbc-addAllFiltered');
    if (f) {
      var n = addableIn(GRID()).length;
      var t = f.querySelector('.aa-n'); if (t) t.textContent = String(n);
      f.disabled = n === 0;
    }
    var s = document.getElementById('bbc-addAllSaved');
    var foot = document.getElementById('bbc-savedFoot');
    if (s) {
      var m = addableSaved().length;
      var st = s.querySelector('.aa-n'); if (st) st.textContent = String(m);
      s.disabled = m === 0;
      if (foot) foot.hidden = m === 0;
    }
  }

  /* toast + cart bubble: bb-coffee.js keeps its own copies inside a closure, so
     these mirror them rather than reach in. Same element id, same classes — two
     toasts can never stack because they are the same node. */
  var _tT;
  function toast(msg) {
    var host = document.getElementById('bbc-app') || document.querySelector('.bbc-root') || document.body;
    var t = document.getElementById('bbc-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'bbc-toast'; t.className = 'toast';
      t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      host.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(_tT); _tT = setTimeout(function () { t.classList.remove('show'); }, 3000);
  }
  /* mirrors bb-coffee.js's updateCartBubble — same header-badge fix, same
     reasoning. Keep both in sync if either changes. */
  function bubble(n) {
    var txt = n < 100 ? String(n) : '99+';
    $$('.bb-cartbadge').forEach(function (el) { el.textContent = txt; });
    $$('.bb-icb.bb-cart, .bb-meta-item.bb-meta-cart').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
    $$('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = n < 100 ? String(n) : ''; el.classList.toggle('hidden', n === 0);
    });
    $$('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', n === 0); });
    $$('cart-icon').forEach(function (el) { el.classList.toggle('header-actions__cart-icon--has-cart', n > 0); });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function addAll(btn, items, label) {
    if (!items.length) return;
    var was = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding ' + items.length + '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || 'add'); });
        return fetch('/cart.js').then(function (x) { return x.json(); });
      })
      .then(function (cart) {
        bubble(cart.item_count || 0);
        var n = items.length;
        toast(n + ' ' + (n === 1 ? label.one : label.many) + ' added to your bag.');
        try { if (window.gtag) window.gtag('event', 'bb_add_all', { count: items.length, source: label.many }); } catch (e) {}
      })
      .catch(function (err) {
        /* most likely an out-of-stock line: Shopify rejects the whole batch, so
           the cart is untouched and the honest message is "nothing was added" */
        toast('Could not add these — ' + (err && err.message ? err.message : 'please try again') + '.');
      })
      .then(function () { btn.disabled = false; btn.innerHTML = was; syncAddAll(); });
  }

  document.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('#bbc-addAllFiltered');
    if (f) { e.preventDefault(); addAll(f, addableIn(GRID()), { one: 'coffee', many: 'coffees' }); return; }
    var s = e.target.closest && e.target.closest('#bbc-addAllSaved');
    if (s) { e.preventDefault(); addAll(s, addableSaved(), { one: 'saved coffee', many: 'saved coffees' }); }
  });

  /* keep the counts honest as Load more appends cards and as favourites change */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#bbc-loadMore')) setTimeout(syncAddAll, 900);
  });
  syncAddAll();
})();
